import { uuid } from "vue-uuid";
import type { Store } from "vuex";
import { RootState } from "@/store/types.ts";
import { RecordColumnDocument } from "@/types/category.ts";

export async function addRecordCollection(
  store: Store<RootState>
): Promise<void> {
  const recordColumns: RecordColumnDocument[] = JSON.parse(
    JSON.stringify(
      store.getters.getStoreVar(
        "Category",
        "page",
        "recordColumns",
        "recordColumns"
      )
    )
  );

  const randomID = uuid.v1();

  const newColumn: RecordColumnDocument = {
    columnID: randomID,
    recordLabel: "New",
    recordType: "Number",
    recordName: store.getters.getStoreVar(
      "Category",
      "page",
      "text",
      "categoryName"
    ),
    recordUnits: "",
    recordSortDirection: "Descending",
  };

  recordColumns.push(newColumn);

  await store.dispatch("api/patchCategory", {
    path: `/category/${store.state.route.params.categoryID}`,
    patch: { recordColumns },
  });

  await store.dispatch("setStoreVar", {
    page: "Category",
    group: "page",
    type: "recordColumns",
    name: "recordColumns",
    value: recordColumns,
  });
}
